export { AddEquipmentFootNote } from './add-equipment-foot-note'